import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import CurrencyColumn from '../../../components/columns/currency-column';
import { USD } from '../../../constants/currency-codes';
import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const RefundedAmountColumn = ({ fulfillmentId }) => {
  const fulfillment = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { netRefundedAmount } = fulfillment;

  if (!netRefundedAmount) {
    return '';
  }

  return <CurrencyColumn currencyCode={USD} value={netRefundedAmount} />;
};

RefundedAmountColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const RefundedAmount = {
  getMessageDescriptor: () => messages.refundedAmount,
  id: 'refunded-amount',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <RefundedAmountColumn fulfillmentId={data.id} />;
  },
};
